import { Container, Loader } from 'component-library';
import { useTranslation } from 'react-i18next';

import { SecondaryNav, withSuspenseBoundary } from '@/components';
import { useScreenSize } from '@/hooks/useScreenSize';
import { SignedInPageLayout } from '@/layout/signed-in-page';

import { useMenuItems } from '../hooks/useMenuItems';
import { PlotListDesktop } from './components/PlotListDesktop';
import { PlotListMobile } from './components/PlotListMobile';

export const PlotsList = withSuspenseBoundary(
  () => {
    const isSmallScreen = useScreenSize() === 'small';

    if (isSmallScreen) return <PlotListMobile />;

    return <PlotListDesktop />;
  },
  <Loader className='min-h-[300px]' />,
);

export const PlotsPage = () => {
  const { t } = useTranslation();
  const menuItems = useMenuItems();
  return (
    <SignedInPageLayout items={menuItems} withCustomContentContainer>
      <SecondaryNav title={t('shared.plots.navbar.allPlots')} />
      <Container gutterWidth={{ sm: 4 }} className='my-10' data-testid='plot-list-page'>
        <PlotsList />
      </Container>
    </SignedInPageLayout>
  );
};
